import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import showDate from 'helpers/date/showDate'

import { EditSmallIcon } from '@pleio/icons/edit-small'

import Button from 'js/components/Button'
import Flexer from 'js/components/Flexer/Flexer'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import Section from 'js/components/Section/Section'
import Text from 'js/components/Text/Text'
import TiptapView from 'js/components/Tiptap/TiptapView'
import { NotFound } from 'js/core/NotFound'
import PollViewForm from 'js/page/Widget/components/Poll/PollViewForm'

import Document from '../components/Document'

import pollDetailFragment from './fragments/detailFragment'

const Item = () => {
    const { t } = useTranslation()
    const params = useParams()
    const { guid } = params

    const { loading, data } = useQuery<any>(POLLS_ITEM, {
        variables: {
            guid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity, viewer } = data
    const { title, timePublished, richDescription, canEdit } = entity

    return (
        <>
            <Document title={title} />
            <Section backgroundColor="white" grow>
                <Container size="normal">
                    <article
                        style={{
                            position: 'relative',
                            marginTop: '32px',
                        }}
                    >
                        <Text size="small" variant="grey">
                            {showDate(timePublished)}
                        </Text>

                        <H1>{title}</H1>

                        {richDescription && (
                            <div style={{ marginBottom: '16px' }}>
                                <TiptapView content={richDescription} />
                            </div>
                        )}

                        <PollViewForm
                            viewer={viewer}
                            entity={entity}
                            legend={title}
                        />

                        {canEdit && (
                            <Flexer justifyContent="flex-start" mt>
                                <Button
                                    variant="tertiary"
                                    size="normal"
                                    as={Link}
                                    to={`/polls/edit/${entity.guid}`}
                                >
                                    <EditSmallIcon
                                        style={{ marginRight: '4px' }}
                                    />
                                    {t('action.edit')}
                                </Button>
                            </Flexer>
                        )}
                    </article>
                </Container>
            </Section>
        </>
    )
}

export const POLLS_ITEM = gql`
    query PollsItem($guid: String!) {
        viewer {
            guid
            loggedIn
        }
        entity(guid: $guid) {
            guid
            ...PollDetailFragment
        }
    }
    ${pollDetailFragment}
`

export default Item
